export default defineNuxtPlugin(() => {
  const { isIntegrationEnabled } = useUtils()

  if (!isIntegrationEnabled('stripe')) return

  const stripe = useStripe()

  // Load Stripe when the app is ready so Radar can begin tracking
  onNuxtReady(stripe.load)
})
